/**
 * BorderBeam — 컨테이너의 border 를 따라 도는 빛 띠 애니메이션.
 *
 * Magic UI 의 border-beam 패턴을 순수 CSS (offset-path + mask-clip) 로 이식.
 * 부모 요소는 `position: relative` + `border-radius` 가 beam 의 경로가 된다.
 *
 * 접근성: `aria-hidden` + `prefers-reduced-motion: reduce` 시 자동 비활성.
 */
interface BorderBeamProps {
	/** 빛 띠의 가로 폭 (px). 컨테이너 대비 적당히 짧게. 기본 200 */
	readonly size?: number
	/** 한 바퀴 도는 시간 (초). 기본 12 */
	readonly duration?: number
	/** 애니메이션 시작 지연 (초). 음수면 이미 진행된 지점에서 시작 */
	readonly delay?: number
	/** 빛의 앞쪽 (진행 방향) 색 — 보통 accent */
	readonly colorFrom?: string
	/** 빛의 꼬리 색 — 보통 transparent */
	readonly colorTo?: string
	/** 부모의 border-radius 값 — 경로의 모서리 반경과 일치해야 부드러움 */
	readonly borderRadius?: string
}

export function BorderBeam(props: BorderBeamProps) {
	const {
		size = 200,
		duration = 12,
		delay = 0,
		colorFrom = "var(--pk-accent)",
		colorTo = "transparent",
		borderRadius = "var(--pk-radius-lg)"
	} = props
	return (
		<span
			className="border-beam"
			aria-hidden
			style={
				{
					"--beam-size": `${size}px`,
					"--beam-duration": `${duration}s`,
					"--beam-delay": `${-delay}s`,
					"--beam-color-from": colorFrom,
					"--beam-color-to": colorTo,
					"--beam-radius": borderRadius
				} as React.CSSProperties
			}
		/>
	)
}
